var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlockTabsHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 1389 \\u2013 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 52,
    viewBox: "0 0 54 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144828",
    style: {
      fill: "#fff"
    },
    d: "M0 0h54v52H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173051"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144827",
    transform: "translate(4 4)",
    style: {
      fill: "#f3f6fa",
      opacity: 0.004
    },
    d: "M0 0h46v44H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173050"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 173049"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12977",
    d: "M84 73.922v16h20v-16zm11.284 1.3h3.095v2h-3.095zm-4.358 0h3.095v2h-3.095zM102.737 88.6H85.263V75.224h4.4v3.3h13.074zm0-11.4h-3.095v-2h3.095z",
    transform: "translate(-67 -62.922)",
    style: {
      fill: "#2162d5"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(27 41)",
    style: {
      fontSize: 10,
      fontFamily: "NunitoSans-Regular,Nunito Sans",
      fill: "#2162d5"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -10.48,
    y: 0
  }, "Tabs"))))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 144830",
    transform: "translate(0 51)",
    style: {
      fill: "#DDDFDD"
    },
    d: "M0 0h54v1H0z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockTabsHover);
export default __webpack_public_path__ + "static/media/BlockTabsHover.9949c59ee738fda8cd5f03cbd786b638.svg";
export { ForwardRef as ReactComponent };